<template>
  <ul class="submenu" :class="{open: $root.currentSubMenu === name}">
    <li v-for="route in routes" :key="route">
      <router-link :to="{name: route, params: { lang: $route.params.lang }}">{{$t(`nav.${route}`)}}</router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'NavSubmenu',
  props: {
    routes: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';

.submenu {
  @media(min-width: $screen-sm-min) {
    display: none;
  }
  background: #e7e6e6;
  overflow-y: hidden;
  max-height: 0;
  li {
    padding: 12px 34px;
    font-weight: 500;
    font-size: px2rem(13);
    margin-bottom: 0;
    a {
      color: #333333;
      text-decoration: none;
    }
  }

  &.open {
    height: auto;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavSubmenu.vue